import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromSystem from './system.reducer';
import { isCriciumaTenant } from './tenant-config.utils';

const selectSystemState = createFeatureSelector<fromSystem.State>('system');

export const selectTenantConfig = createSelector(
  selectSystemState,
  fromSystem.getTenantConfig
);

// Serviços criados antes de o estado 'system' ser registrado leem este seletor:
// selectTenantConfig lança erro enquanto o estado não existe.
export const selectIsCriciuma = createSelector(selectSystemState, (state) =>
  isCriciumaTenant(state?.tenantConfig)
);
